<div class="layout-row layout-wrap profile-page">
    <div [class.flex-32]="isActiveUser && !this.disallowPasswordChange"
         [class.flex-50]="!isActiveUser && this.disallowPasswordChange ||
                        isHost && !this.disallowPasswordChange"
         [class.flex-sm-50]="!isHost && !this.disallowPasswordChange"
         [class.flex-sm-100]="isHost && this.disallowPasswordChange"
         class="card-container flex flex-md-50 flex-sm-100 flex-xs-100">
        <mat-card>
            <mat-card-header>
                <mat-card-title>
                    {{ 'profile_tab_general' | translate }}
                </mat-card-title>
                <div class="mat-card-header-actions">
                    <button *ngIf="!general.edit && !isViewOnly"
                            [matTooltip]="'profile_edit_tooltip' | translate"
                            [disabled]="!(isEditable$ | async) || isDirectoryEntity"
                            (click)="general.editMode()"
                            mat-icon-button
                            data-cy="open-edit"
                            type="button">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button *ngIf="general.edit"
                            [matTooltip]="'profile_cancel_tooltip' | translate"
                            (click)="general.viewMode()"
                            mat-icon-button
                            data-cy="close-edit"
                            type="button">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </mat-card-header>
            <mat-card-content>
                <ui-user-profile-general #general
                                         [user]="viewedUser"
                                         [isLoading]="loading.user$ | async"
                                         [isActiveUser]="isActiveUser"
                                         (enterViewMode)="onEnterUserViewMode()"
                                         (submitUser)="onSubmitUser($event)">
                </ui-user-profile-general>
            </mat-card-content>
        </mat-card>
    </div>
    <div *ngIf="!isHost && viewedUser.type !== UserType.DirectoryGroup"
         [class.flex-32]="isActiveUser && !this.disallowPasswordChange"
         [class.flex-50]="!isActiveUser && this.disallowPasswordChange"
         class="card-container flex flex-md-50 flex-sm-50 flex-xs-100">
        <mat-card>
            <mat-card-header>
                <mat-card-title>
                    {{ 'profile_tab_notifications' | translate }}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <section class="mat-typography">
                    <p translate
                       tabindex="0">
                        notifications_settings_explanation
                    </p>
                    <ui-user-profile-notifications [notificationTranslations]="{
                                                        transactions: 'notifications_settings_transactions_notification' | translate,
                                                        robots: 'notifications_settings_robots_notification' | translate,
                                                        jobs: 'notifications_settings_jobs_notification' | translate,
                                                        schedules: 'notifications_settings_schedules_notification' | translate,
                                                        tasks: 'notifications_settings_tasks_notification' | translate,
                                                        queues: 'notifications_settings_queues_notification' | translate
                                                    }"
                                                   [viewOnly]="!(isEditable$ | async)"
                                                   [notificationSettings]="notificationSettings"
                                                   [controlsAccess]="notificationSettingsPermissions"
                                                   [notificationRightsWarning]="'notifications_settings_subscription_rights_warning' | translate"
                                                   [isLoadingMap]="loading.notifications"
                                                   (notificationChanged)="updateNotifications($event)">
                    </ui-user-profile-notifications>
                </section>
            </mat-card-content>
        </mat-card>
    </div>
    <div *ngIf="isActiveUser &&
                !this.disallowPasswordChange &&
                !isDirectoryEntity"
         [class.flex-32]="!isHost"
         [class.flex-50]="isHost"
         [class.flex-md-100]="!isHost"
         class="card-container flex flex-md-100 flex-sm-100 flex-xs-100">
        <mat-card>
            <mat-card-header>
                <mat-card-title>
                    {{ 'profile_tab_security' | translate }}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <ui-user-profile-security [isLoading]="loading.password$ | async"
                                          (submitPassword)="onSubmitPassword($event)">
                </ui-user-profile-security>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div *ngIf="viewedUser.type !== UserType.DirectoryGroup"
     class="card-container">
    <mat-card>
        <mat-card-header>
            <mat-card-title>
                {{ 'profile_tab_login_attempts' | translate }}
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <ui-login-attempts-grid [userId]="viewedUser.id">
            </ui-login-attempts-grid>
        </mat-card-content>
    </mat-card>
</div>
